<template>
  <svg width="24" height="25" viewBox="0 0 24 25"  xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9999 16.9409C11.7719 16.9409 11.5449 16.8639 11.3599 16.7089L5.35991 11.7089C4.93591 11.3559 4.87791 10.7249 5.23191 10.3009C5.58491 9.8769 6.21491 9.8199 6.63991 10.1729L12.0109 14.6489L17.3729 10.3339C17.8029 9.9879 18.4329 10.0559 18.7789 10.4859C19.1249 10.9159 19.0569 11.5449 18.6269 11.8919L12.6269 16.7199C12.4439 16.8669 12.2219 16.9409 11.9999 16.9409Z"
      
    />
  </svg>
</template>
